export var PopoverVariantType;
(function (PopoverVariantType) {
    PopoverVariantType["SNACKBAR_TOP"] = "SNACKBAR_TOP";
    PopoverVariantType["SNACKBAR_BOTTOM"] = "SNACKBAR_BOTTOM";
    PopoverVariantType["BADGE"] = "BADGE";
    PopoverVariantType["MODAL"] = "MODAL";
    PopoverVariantType["TOOLTIP"] = "TOOLTIP";
    PopoverVariantType["INPUT_SEARCH"] = "INPUT_SEARCH";
    PopoverVariantType["INPUT_DATE"] = "INPUT_DATE";
    PopoverVariantType["ACTION_BOTTOM_SHEET"] = "ACTION_BOTTOM_SHEET";
    PopoverVariantType["DRAWER_RIGHT"] = "DRAWER_RIGHT";
    PopoverVariantType["DRAWER_LEFT"] = "DRAWER_LEFT";
    PopoverVariantType["DRAWER_BOTTOM"] = "DRAWER_BOTTOM";
    PopoverVariantType["SELECT_CONTEXT_MENU"] = "SELECT_CONTEXT_MENU";
    PopoverVariantType["DROPDOWN_MULTISELECT"] = "DROPDOWN_MULTISELECT";
})(PopoverVariantType || (PopoverVariantType = {}));
//# sourceMappingURL=variants.js.map